import React, { useState } from 'react';
import axios from 'axios';

import ErrorModal from '../error-modal/ErrorModal';
import { SUBMIT_REVIEW } from 'constants/API';
import './customer-feedback-screen.css';

const CustomerFeedbackScreen = () => {
  const [rating1, setRating1] = useState(0);
  const [rating2, setRating2] = useState(0);
  const [rating3, setRating3] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [showMassage, setShowMassage] = useState('');
  const [showThankYouScreen, setShowThankYouScreen] = useState(false);

  const urlParams = new URLSearchParams(location.search);
  const token = urlParams.get("token");

  const StarRating = ({ rating, setRating }) => {
    return (
      <div className="star-rating">
        {[1, 2, 3, 4, 5].map((star) => (
          <span
            key={star}
            className={`star ${star <= rating ? 'filled' : ''}`}
            onClick={() => setRating(star)}
          >
            ★
          </span>
        ))}
      </div>
    )
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (rating1 <= 0 || rating2 <= 0 || rating3 <= 0) {
      setShowMassage("Please select mandatory input")
      return
    }

    const requestObj = {
      token: token,
      overall_rating: rating1,
      behavior_rating: rating2,
      advice_rating: rating3,
      comments: feedback
    }

    let response = await axios.post(SUBMIT_REVIEW, requestObj)

    if(response?.data.status){
      setShowThankYouScreen(true)
    }
  
    setRating1(0);
    setRating2(0);
    setRating3(0);
    setFeedback('');
  };

  return (
    <>
      {!showThankYouScreen &&
        <div className="feedback-container">
          <h1 className="feedback-title text-center">Your Feedback matters a lot!</h1>
          <p className="feedback-subtitle">
            Good or Bad, we would like to hear from you!<br />
            Your honest & valuable feedback help us to provide you the best services.
          </p>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>
                How would you rate your overall experience <span className="required">*</span>
              </label>
              <StarRating rating={rating1} setRating={setRating1} />
            </div>

            <div className="form-group">
              <label>
                How satisfied are you with our representative's professionalism and behaviour? <span className="required">*</span>
              </label>
              <StarRating rating={rating2} setRating={setRating2} />
            </div>

            <div className="form-group">
              <label>
                How useful did you find the need-analysis process and the advice by the advisor? <span className="required">*</span>
              </label>
              <StarRating rating={rating3} setRating={setRating3} />
            </div>

            <div className="form-group">
              <label>
                Please share a few words on your experience and your interaction with our representative
              </label>
              <textarea
                className="feedback-textarea"
                placeholder="Share your experience."
                value={feedback}
                onChange={(e) => setFeedback(e.target.value)}
              />
            </div>

            <button type="submit" className="submit-btn">
              Submit
            </button>
            <div className="note">Your feedback helps us serve you better</div>
          </form>
        </div>
      }
      {showThankYouScreen &&
        <div className="thank-you-screen">
          <div className="thank-you-content">
            <h1 className="thank-you-title">Thank you for your feedback!</h1>
            <p className="thank-you-subtitle">We appreciate your time and valuable input.</p>
          </div>
        </div>
      }
      <ErrorModal
        onHideModal={() => { setShowMassage("") }}
        showModal={showMassage ? true : false}
        title={showMassage}
        hideResumeSession={true} />

    </>
  )
}

export default CustomerFeedbackScreen;